import { schema } from "normalizr";
import { DeliveryWindowSchema } from "./delivery-window";

export const DeliveryWindowsSchema = new schema.Array(DeliveryWindowSchema);
